import React from 'react';

import { Card, CardText, CardMedia, CardTitle } from 'material-ui/Card';

import {indigo400,redA400,lightBlueA400,amberA400} from 'material-ui/styles/colors';


export default class Benefit extends React.Component{
  render(){
    return(
      <ul>
        <Card className="Header-Benefit">

          <CardText >
            <div className="row">
              <div className="Header-Benefit-image" style={{'backgroundColor': redA400}}>
                <img src={process.env.PUBLIC_URL + '/img/like.png'} />
              </div>
              <div className="Header-Benefit-content">
                <h3>Qualifications with Emojis</h3>
                <p>Rate your favorite places with experiences</p>
              </div>
            </div>

          </CardText>
        </Card>
        <Card className="Header-Benefit">

          <CardText >
            <div className="row">
              <div className="Header-Benefit-image" style={{'backgroundColor': lightBlueA400}}>
                <img src={process.env.PUBLIC_URL + '/img/no-wifi.png'} />
              </div>
              <div className="Header-Benefit-content">
                <h3>Without Internet???</h3>
                <p>this web app works without internet or in slow connections</p>
              </div>
            </div>

          </CardText>
        </Card>
        <Card className="Header-Benefit">

          <CardText >
            <div className="row">
              <div className="Header-Benefit-image" style={{'backgroundColor': amberA400}}>
                <img src={process.env.PUBLIC_URL + '/img/star.png'} />
              </div>
              <div className="Header-Benefit-content">
                <h3>No problem</h3>
                <p>this web app is developed with the most optimal and innovative standards Tech</p>
              </div>
            </div>

          </CardText>
        </Card>

      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Benefits.js